var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container mt-6 mb-6"},[_c('p',{staticClass:"is-size-7"},[_c('span',[_vm._v(" Version: "+_vm._s(_vm.version)+" ")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }